import { useParams } from "react-router-dom";
import { selectResourceById, setExpandedItemByDepth, setSelectedTreeItemByResourceId } from "../layoutSlice";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/storeHooks";

export const usePathAwareItemSelection = () => {
  const dispatch = useAppDispatch();
  const { customerId, siteId, locationId, meterId } = useParams();
  const lastValidId = meterId || locationId || siteId || customerId;
  const lastValidType = meterId ? "meter" : locationId ? "location" : siteId ? "site" : "customer";
  const resource = useAppSelector((state) => selectResourceById(state, `${lastValidType}-${lastValidId}`));

  React.useEffect(() => {
    const defaultExpandedItems = [
      customerId ? `customer-${customerId}` : null,
      siteId ? `site-${siteId}` : null,
      locationId ? `location-${locationId}` : null,
      meterId ? `meter-${meterId}` : null,
    ].filter(Boolean);

    defaultExpandedItems.forEach((id, index) => {
      dispatch(setExpandedItemByDepth({ depth: index, itemId: id || "" }));
    });

    dispatch(setSelectedTreeItemByResourceId(`${lastValidType}-${lastValidId}`));
  }, [customerId, dispatch, locationId, meterId, siteId, resource, lastValidType, lastValidId]);
};
